import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import type { ModalSize, ModalStyle } from 'af-components/CustomModal';
import CustomModal from 'af-components/CustomModal';

export interface OwnProps {
	showModal: boolean;
	closeModal: () => void;
	confirmAction?: Nullable<() => void | Promise<void>>;
	title: string | undefined | null;
	body: React.JSX.Element | string | undefined | null;
	footer?: React.JSX.Element;
	confirmText?: Nullable<string>;
	size?: ModalSize;
	modalStyle?: ModalStyle;
	closeText?: string;
	id?: string;
	hideOnConfirm?: boolean;
	disabled?: boolean;
	showCancel?: boolean;
	hideConfirmButton?: boolean;
}

type Props = OwnProps;

const ConfirmationModal: React.FC<Props> = (props) => {
	const {
		id,
		showModal,
		closeText = 'Cancel',
		closeModal,
		confirmText = 'Save',
		title,
		body,
		size = 'sm',
		modalStyle = 'danger',
		footer,
		disabled,
		showCancel = true,
		hideConfirmButton,
		hideOnConfirm = true,
		confirmAction,
	} = props;

	const [isSubmitting, setIsSubmitting] = React.useState(false);
	const isSubmittingRef = React.useRef(false);

	const onClick = React.useCallback(async () => {
		if (disabled || isSubmittingRef.current) {
			return;
		}

		isSubmittingRef.current = true;
		setIsSubmitting(true);

		try {
			if (hideOnConfirm) {
				closeModal();
			}

			await confirmAction?.();
		} finally {
			isSubmittingRef.current = false;
			setIsSubmitting(false);
		}
	}, [closeModal, confirmAction, disabled, hideOnConfirm]);

	return (
		<CustomModal
			closeModal={closeModal}
			id={id}
			modalStyle={modalStyle}
			showModal={showModal}
			size={size}
		>
			<CustomModal.Header
				closeModal={closeModal}
				title={title}
			/>
			<CustomModal.Body>
				{body}
			</CustomModal.Body>
			<CustomModal.Footer>
				{footer ??
					<>
						{showCancel &&
							<Button
								label={closeText}
								onClick={closeModal}
								style="secondary"
							/>
						}
						{
							!hideConfirmButton && !!confirmText &&
							<Button
								disabled={!!disabled || !!isSubmitting}
								label={confirmText}
								onClick={onClick}
								style={modalStyle === 'danger' ? 'danger' : 'primary'}
							/>
						}
					</>
				}
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(ConfirmationModal);
